var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"touch-strip",on:{"click":_vm.openMore}},[_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('i',{staticClass:"arrow"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0edb35c0","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./libs/components/TouchStrip.vue
// module id = 604
// module chunks = 0 1